import $ from "jquery"

import barba from '@barba/core'
import barbaCss from '@barba/css'
import barbaPrefetch from '@barba/prefetch'
import setPickupSlide from './front-pickups.js'
import setRecruitRelative from './single-recruit-relative.js'

barba.use(barbaCss)
barba.use(barbaPrefetch)
barba.init({
  views: [
    {
      namespace: 'home',
      afterEnter(data) {
        setPickupSlide()
	　}
  	},
    {
      namespace: 'single',
      afterEnter(data) {
		    setRecruitRelative()
      }
    }
  ]

});

// transition hook replace
barba.hooks.enter(() => {
	window.scrollTo(0, 0);
});
barba.hooks.beforeEnter(({ next }) => {
  replaceHeadTags(next);
  gaPush(location.pathname);
});

const eventDelete = e => {
  if (e.currentTarget.href === window.location.href) {
    e.preventDefault()
    e.stopPropagation()
    return
  }
}

const links = [...document.querySelectorAll('a[href].no-pjax')]
links.forEach(link => {
  link.addEventListener('click', e => {
    eventDelete(e)
  }, false)
})

// metaタグ情報の書き換え
const replaceHeadTags = target => {
  const head = document.head
  const targetHead = target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0]
  const newPageHead = document.createElement('head')
  newPageHead.innerHTML = targetHead
  const removeHeadTags = [
    "meta[name='keywords']",
    "meta[name='description']",
    "meta[property^='fb']",
    "meta[property^='og']",
    "meta[name^='twitter']",
    "meta[name='robots']",
    'meta[itemprop]',
    'link[itemprop]',
    "link[rel='prev']",
    "link[rel='next']",
    "link[rel='canonical']",
  ].join(',')
  const headTags = [...head.querySelectorAll(removeHeadTags)]
  headTags.forEach(item => {
    head.removeChild(item)
  })
  const newHeadTags = [...newPageHead.querySelectorAll(removeHeadTags)]
  newHeadTags.forEach(item => {
    head.appendChild(item)
  })
}

// Google Analyticsに情報を送信
const gaPush = pagename => {
  ga('send', 'pageview', pagename)
}


//-------------------------------------------------------------
//初期化

let setToggleBtn = () => {
	const $toggleBtn = $('.js-servicects__more')
	const $toggleArea = $('.js-servicects__more--content')

	$toggleBtn.each(function(i) {
		$(this).on('click', function(e) {
			e.preventDefault()
			const _this = $(this)
			if(_this.hasClass('is-open')) {
				_this.next('.js-servicects__more--content').fadeOut(500, function() {
					$toggleBtn.removeClass('is-open');
				})
			} else {
				_this.next('.js-servicects__more--content').fadeIn(500, function() {
					$toggleBtn.addClass('is-open');
				})
			}
		})
	});
}

let init = () => {
	// $('.js-scroll').cmn_scrollbtn();
}

const lib = (function() {
	
	setToggleBtn()
	init()

})();

